import { createBehavior } from '@area17/a17-behaviors';

const scrollTop = createBehavior(
  'scrollTop',
  {},
  {
    init() {
      window.requestAnimFrame = (function () {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          function (callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();

      // main function
      function scrollToY(scrollTargetY, speed, easing) {
        // scrollTargetY: the target scrollY property of the window
        // speed: time in pixels per second
        // easing: easing equation to use

        let scrollY = window.scrollY;
        let scrollTargetYSet = scrollTargetY || 0;
        let speedSet = speed || 2000;
        let easingSet = easing || 'easeOutSine';
        let currentTime = 0;

        // min time .1, max time .8 seconds
        const time = Math.max(
          0.1,
          Math.min(Math.abs(scrollY - scrollTargetYSet) / speedSet, 0.8)
        );

        // easing equations from https://github.com/danro/easing-js/blob/master/easing.js

        const easingEquations = {
          easeOutSine: function (pos) {
            return Math.sin(pos * (Math.PI / 2));
          },
          easeInOutSine: function (pos) {
            return -0.5 * (Math.cos(Math.PI * pos) - 1);
          },
          easeInOutQuint: function (pos) {
            if ((pos /= 0.5) < 1) {
              return 0.5 * Math.pow(pos, 5);
            }
            return 0.5 * (Math.pow(pos - 2, 5) + 2);
          },
        };

        // add animation loop
        function tick() {
          currentTime += 1 / 60;

          const p = currentTime / time;
          const t = easingEquations[easingSet](p);

          if (p < 1) {
            requestAnimFrame(tick);

            window.scrollTo(0, scrollY + (scrollTargetYSet - scrollY) * t);
          } else {
            window.scrollTo(0, scrollTargetYSet);
          }
        }

        // call it once to get started
        tick();
      }

      this.$node.addEventListener('click', () => {
        scrollToY(0, 800, 'easeInOutQuint');
      });
    },
    destroy() {},
  }
);

export default scrollTop;
